export const setMedias = (medias) => ({
    type: "SET_MEDIAS",
    payload: medias,
  });